// extracted by mini-css-extract-plugin
export var button = "share-buttons-module--button--ADnNZ";
export var container = "share-buttons-module--container--wnwHY";
export var facebook = "share-buttons-module--facebook--J-En3";
export var linkedin = "share-buttons-module--linkedin--bsScb";
export var messenger = "share-buttons-module--messenger--KOmtL";
export var shareButtons = "share-buttons-module--share-buttons--1aSMt";
export var telegram = "share-buttons-module--telegram--jehUh";
export var title = "share-buttons-module--title--CGkzU";